import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ReportDataService} from '../report-data.service';
import {Report} from '../shared/report.model';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../environments/environment.dev';
import { MappingComponent} from '../mapping/mapping.component';
import { CostHourDefinitionsMap } from '../shared/data/CostHourDefinitionsMap';
import { ReportingCalendarMap } from '../shared/data/ReportingCalendarMap';
import { ActualCostHourDataMap } from '../shared/data/ActualCostHourDataMap';
import { ActualCostHourDataComponent } from '../actual-cost-hour-data/actual-cost-hour-data.component';

@Component({
  selector: 'app-start-wizard-modal',
  templateUrl: './start-wizard-modal.component.html',
  styleUrls: ['./start-wizard-modal.component.scss']
})
export class StartWizardModalComponent implements OnInit {
  state = 'LoadFiles';
  report: Report;
  lockButtons = false;
  fileData = [];
  noNext = true;
  costHourDefinitionsMap: CostHourDefinitionsMap;
  reportingCalMap: ReportingCalendarMap;
  actualCostHourMap: ActualCostHourDataMap;
  //report config options
  detailedStandardCat = false;
  GA = false;
  FCCM = false;
  NonRecurring = false;
  FACStandardCat = false;

  constructor(public bsModalRef: BsModalRef, private reportService: ReportDataService, private loadingBar: SlimLoadingBarService, private toastr: ToastrService) {
    this.reportService.getRawFileData().subscribe(value => this.fileData = value);
    this.costHourDefinitionsMap = new CostHourDefinitionsMap(this.reportService);
    this.reportingCalMap = new ReportingCalendarMap(this.reportService);
    this.actualCostHourMap = new ActualCostHourDataMap(this.reportService);
    this.report = this.reportService.getReport();
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
  }

  loadPlan(event) {
    this.reportService.parsePlan(event);
    this.state = 'PlanLoadedConfirm';
    this.noNext = false;
  }

  doNext(event) {
    if ((this.state === 'PlanLoadedConfirm') || (this.state === 'FlexFileLoadedConfirm')) {
      this.state = 'ReportConfig';
      return;
    }
    if (this.state === 'MapFiles') {
      this.state = 'MapCostDef';
      return;
    }
    if (this.state === 'MapCostDef') {
      ///validate that cost hour def table has all required cols populated
      //TEMP DISABLING VALIDATION FOR TESTING
      this.reportService.storeNameIDVariations();
      /*
      if (!this.reportService.isCostDefinitionMapped()) {
        this.toastr.error('Sorry, we need you to map everything in the Cost Definition table except for the tags before you can continue :(', 'Incomplete Mapping');
        return;
      }
      */
      this.state = 'MapReportingCal';
      return;
    }
    if (this.state === 'MapReportingCal') {
      //validate that cost hour table has all required cols populated
      //TEMP DISABLING VALIDATION FOR TESTING
      /*
      if (!this.reportService.isReportingCalMapped()) {
        this.toastr.error('Sorry, we need you to map Start and End dates before you can continue :(', 'Incomplete Mapping');
        return;
      }
      */
      this.state = 'MapActualCostHour';
      return;
    }
    if (this.state === 'MapActualCostHour') {
      //validate that actual cost hour table has all required cols populated
      //TEMP DISABLING VALIDATION FOR TESTING
      /*
      if (!this.reportService.isActualCostMapped()) {
        this.toastr.error('Sorry, we need you to map actual cost and hours columns before you can continue :(', 'Incomplete Mapping');
        return;
      }
      */
      this.state = 'Finished';
      this.reportService.finalizeMaps();
      return;
    }
    if (this.state === 'ReportConfig') {
      //push config values into report.  This is a little janky, but don't think it's worth refactoring everything to just make it cleaner
      this.report.ReportConfiguration.data[0] = {Value: this.detailedStandardCat};
      this.report.ReportConfiguration.data[1] = {Value: this.GA};
      this.report.ReportConfiguration.data[2] = {Value: this.FCCM};
      this.report.ReportConfiguration.data[3] = {Value: this.NonRecurring};
      this.report.ReportConfiguration.data[4] = {Value: this.FACStandardCat};
      this.state = 'MapFiles';
      return;
    }
  }

  loadCSV(event) {
    this.lockButtons = true;
    this.loadingBar.start();
    this.reportService.parseCSV(event).then((data) => {
      this.loadingBar.complete();
      this.lockButtons = false;
    });
  }

  loadJSON(event) {
    this.reportService.parseJSON(event);
    this.state = 'FlexFileLoadedConfirm';
    this.noNext = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/start-wizard-modal/start-wizard-modal.component.ts